import _extend from 'lodash/extend';

/**
 * User class.
 */
export default class User {
    /**
     * @param {Object} data - User data
     * @constructor
     */
    constructor(data) {
        _extend(this, data);

        this.fullName = this.fullName || `${this.first_name} ${this.last_name}`;
    }
}



// WEBPACK FOOTER //
// ./app/services/api/users/user.class.js